import { z } from 'zod';

/**
 * Zod schemas for company settings
 * These provide runtime validation and type inference
 */

// CompanySettings schema
export const companySettingsSchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'Company name is required'),
  address: z.string().min(1, 'Address is required'),
  supportEmail: z.string().email(),
  website: z.string().url().or(z.literal('')),
  logo: z.string(),
  primaryColor: z.string(),
  currency: z.string().min(1, 'Currency is required'),
  dateFormat: z.string().min(1, 'Date format is required'),
  closingDate: z.string().nullable().optional(),
});

export type CompanySettings = z.infer<typeof companySettingsSchema>;
